import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row, Spinner, Container, } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import "../../App.css"
import useSuccessScreenHook from "../../CustomHook";
import { useDispatch, useSelector } from "react-redux";
import { createEnquiryReq, fetchProducts, resetEquiryStatus, verifyBusinessDecrypt } from "../enquirySlice";
import AddressSection from "../components/AddressSection";
import Name from "../components/fields/Name";
import Mobile from "../components/fields/Mobile";
import FollowUpDate from "../components/fields/FollowUpDate";
import Product from "../components/fields/product";
import Notes from "../components/fields/notes";
import FooterSection from "../components/FooteSection";
import EnquirySuccessScreen from "../components/EnquirySuccessScreen";
import { toast, ToastContainer } from "react-toastify";
import errorImage from '../../assets/images/error.png'
import { fetchSetting } from "../../Settings/store/settingSlice";


const EnquiryForm = () => {
    const dispatch = useDispatch();
    const formikRef = useRef(null);
    const showSuccessScreen = useSuccessScreenHook();

    const { tenant_id, auth_token, createStatus, loading, errorStatus, error } = useSelector((state) => state?.enquiry);
    const businessDetails = useSelector((state) => state?.getSetting?.dataSetting);

    const [selectedItem, setSelectedItem] = useState([]);
    const [followupDate, setFollowupDate] = useState(null);
    const [showError, setShowError] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const encryptedValue = params.keys().next().value;

        if (encryptedValue) {
            dispatch(verifyBusinessDecrypt(encryptedValue));
        } else {
            setShowError(true);
        }
    }, []);

    useEffect(() => {
        if (tenant_id) {
            dispatch(fetchProducts({ token: auth_token, tenant_id: tenant_id }));
            dispatch(fetchSetting({ accessToken: auth_token, tenant_id: tenant_id }));
        }
    }, [tenant_id]);

    useEffect(() => {
        document.title = businessDetails ? `Enquiries - ${businessDetails?.business_name}` : 'React App';
    }, [businessDetails])


    const handleProductSelect = (selected) => {
        setSelectedItem(selected);
    };

    const handleFollowupDateChange = (date) => {
        setFollowupDate(date);
    };

    const resetForm = () => {
        formikRef.current?.resetForm();
        setSelectedItem([]);
        setFollowupDate(null);
    };

    useEffect(() => {
        if (createStatus) {
            localStorage.setItem("lastEnquiryTime", new Date().toISOString());
            resetForm();
            dispatch(resetEquiryStatus())
        }
    }, [createStatus])

    useEffect(() => {
        if (errorStatus) {
            toast.error(error)
            dispatch(resetEquiryStatus())
        }
    }, [errorStatus])

    if (showError) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                <div className="text-center p-4 border rounded shadow-sm bg-white">
                    <img
                        src={errorImage}
                        alt="Error"
                        style={{ width: "80px", marginBottom: "20px" }}
                    />
                    <h3 className="text-danger mb-3">Invalid or Missing Link</h3>
                    <p className="text-muted">
                        The URL you used is missing a required parameter or is not valid.
                    </p>
                </div>
            </div>
        )
    }
    return (
        <>
            <ToastContainer />
            <Container fluid className="py-4" style={{ height: 'calc(100vh - 20px)', overflowY: 'scroll', overflowX: 'hidden' }}>
                <div className="d-flex flex-column align-items-center w-100">
                    <div className="form-container shadow-md py-4 px-3 px-md-5 w-100" style={{ maxWidth: '500px' }}>
                        <Formik
                            innerRef={formikRef}
                            initialValues={{
                                name: "",
                                mobile: "",
                                product_id: null,
                                notes: "",
                                status: true,
                                created_by: 1,
                                updated_by: 1,
                            }}
                            validationSchema={Yup.object().shape({
                                name: Yup.string().required("Please enter a name"),
                                mobile: Yup.string()
                                    .required("Please enter a mobile number")
                                    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits"),
                            })}
                            onSubmit={async (values, { setSubmitting }) => {
                                values.product_id = selectedItem.length ? selectedItem[0].id : null;
                                values.followup_date = followupDate ? followupDate.toISOString().split('T')[0] : null;

                                const data = {
                                    values: values,
                                    tenant_id: tenant_id,
                                    token: auth_token
                                }

                                try {
                                    dispatch(createEnquiryReq(data));
                                } catch (err) {
                                    console.error("Error submitting form:", err);
                                }
                                setSubmitting(false);
                            }}
                        >
                            {({ values, handleChange, handleSubmit, errors, touched, resetForm }) => (
                                <>
                                    <AddressSection />

                                    {!showSuccessScreen && (
                                        <Form className="w-100" onSubmit={handleSubmit}>
                                            <Row className="mt-4">
                                                <Col md={6}>
                                                    <Name values={values} handleChange={handleChange} touched={touched} errors={errors} />
                                                </Col>
                                                <Col md={6}>
                                                    <Mobile values={values} handleChange={handleChange} touched={touched} errors={errors} />
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                <Col xs={12}>
                                                    <Product
                                                        values={values}
                                                        handleChange={handleChange}
                                                        touched={touched}
                                                        errors={errors}
                                                        selectedItem={selectedItem}
                                                        handleProductSelect={handleProductSelect}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                <Col xs={12}>
                                                    <FollowUpDate
                                                        values={values}
                                                        handleChange={handleChange}
                                                        touched={touched}
                                                        errors={errors}
                                                        followupDate={followupDate}
                                                        handleFollowupDateChange={handleFollowupDateChange}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row className="mt-3">
                                                <Col xs={12}>
                                                    <Notes values={values} handleChange={handleChange} touched={touched} errors={errors} />
                                                </Col>
                                            </Row>

                                            <Row className="mt-2">
                                                <Col className="text-start">
                                                    <Form.Label style={{ color: 'grey' }}>* Required fields</Form.Label>
                                                </Col>
                                            </Row>

                                            <Row className="mt-4">
                                                <Col className="d-flex justify-content-center">
                                                    <Button type="submit" variant="primary" className="w-75 w-md-50" disabled={loading}>
                                                        {loading ? <Spinner animation="border" size="sm" /> : "Submit"}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    )}

                                    {showSuccessScreen && <EnquirySuccessScreen />}
                                </>
                            )}
                        </Formik>
                    </div>

                    <div className="w-100 mt-4">
                        <FooterSection />
                    </div>
                </div>
            </Container>

        </>
    )
}

export default EnquiryForm;